import {
  useEffect,
  useRef,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import {
  Box,
  Button,
  IconButton,
  Image,
  Input,
  Skeleton,
  Stack,
  Text
} from '@chakra-ui/react'
import { LoadingSpinier } from 'common/Loading'
import {
  ArrowIcon,
  CopyIcon,
  PaperClipIcon,
  SendIcon,
  SettingsIcon
} from 'assets/icons'
import { ImagesPng } from 'assets/images'
import {
  handleOpenModal,
  markersSelectors,
  pinFriend,
  usersSelectors,
  setChosenFriends,
  setCloseChatModal,
  setHideChat,
  setSharingToFriends,
  setMsgInputForBlogSharing,
  setCloseAllDrawers,
  setChatSectionPage,
  sharePost,
  setUserSectionPage,
  setOpenPopupBlogs,
  setOpenPopupEvents,
  setNotificationSectionPage,
  setBlogRepostData
} from 'store'
import { chatCredentialsSelectors } from 'store/chat/selectors'
import {
  clearConnectedProfileChat,
  setForceCloseChatPanel,
  endMobileImagePicker,
  hideModalSpinner
} from 'store/chat/slice'
import {
  AnimatePresence,
  motion
} from 'framer-motion'
import {
  MODAL_SECTION,
  PENDING
} from 'utils/constants'
import {
  chatCounter,
  isAuth,
  showCoordParams
} from 'utils/helpers'
import { COLORS } from 'utils/styles'

import {
  DropdownCheckBox,
  DropdownStack,
  DropdownStackParent,
  StyleMessengerBlock,
  StyleNumUnread
} from './styled'

const MotionBox = motion(Box)

export const Messenger = () => {
  const {
    user,
    userProfile,
    blogLinkToBeCopied,
    chosenFriends,
    notificationSectionPage,
    openChatModal,
    closeChatModal,
    sharingToFriends,
    hideChat,
    closeAllDrawers,
    getProfileItemStatus,
    chatSectionPage
  } = useSelector(usersSelectors)
  const {
    selectedEventData,
    selectedMarkerData
  } = useSelector(markersSelectors)
  const {
    numUnread,
    isXmppModalSpinnerHidden,
    isMobileImagePickerState,
    isMobileImageTransferInprogress,
    xmppChatPanelOpened,
    forceCloseChatPanel,
    meXmppIsOnline
  } = useSelector(chatCredentialsSelectors)

  const btnRef = useRef()
  const pinBtnRef = useRef()
  const dispatch = useDispatch()
  let touchStart
  let touchEnd

  const [converseRoot, setConverseRoot] = useState()
  const [showDropdown, setShowDropdown] = useState(false)
  const [hideDropdownAnimate, setHideDropdownAnimate] = useState(false)
  const [attachmentBtnDisplay, setAttachmentBtnDisplay] = useState('none')
  const [isPinned, setIsPinned] = useState(false)
  const [msgInput, setMsgInput] = useState('')
  const [copyBtnClicked, setCopyBtnClicked] = useState(false)
  const [sendBtnClicked, setSendBtnClicked] = useState(false)
  const [runHidePanel, setRunHidePanel] = useState(false)
  const [hidePanelAnimation, setHidePanelAnimation] = useState(false)
  const [runClosingAnimation, setRunClosingAnimation] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()
  const [shareText, setShareText] = useState('Article sent! Share with some friends who are not on Connector yet?')
  const [isLoaded, setIsLoaded] = useState(false)

  const friendId = document.querySelector('converse-chat-content')?.getAttribute('jid')?.split('-')[0] ?? 0

  const handleOpen = () => {
    if (document.querySelector('#NOTIFICATIONS-panel') === null) {
      dispatch(handleOpenModal({
        isOpen: chatSectionPage?.length,
        section: MODAL_SECTION.RightSection
      }))
    }
    setSearchParams({})

    dispatch(setChatSectionPage('chat-main'))
    dispatch(setHideChat(false))
    setRunClosingAnimation(!chatSectionPage?.length)

    localStorage.setItem('chatOpenedOn', new Date().toISOString())
    sessionStorage.setItem('isChatPanelOpen', 'true')
    sessionStorage.removeItem('chosenFriends')
    sessionStorage.removeItem('openProfileAfterAnimation')
    sessionStorage.removeItem('openEventAfterAnimation')

    // This is to ensure that chat panel display chat list when sharing blog
    setTimeout(() => {
      if (document.querySelector('#send-attachment-btn') && sharingToFriends) {
        document.querySelector('#chat-back-btn')?.click()
      }

      // Close chat panel if it is opened
      // to prevent user sending messages after unfriending
      const isForceCloseChatPanel = forceCloseChatPanel
      if (isForceCloseChatPanel) {
        dispatch(setForceCloseChatPanel(false))
        const isChatShown = xmppChatPanelOpened
        if (isChatShown) {
          setTimeout(() => {
            // close chat panel after the drawer opening animation is complete
            const event = new CustomEvent('custom-chat-close_chat_panel')
            window.dispatchEvent(event)
          }, 350)
        }
      }
    }, 500)
  }

  const closeMessenger = (options) => {
    if (isMobileImagePickerState && !isMobileImageTransferInprogress) {
      dispatch(endMobileImagePicker())
      dispatch(hideModalSpinner())
    }

    dispatch(handleOpenModal({
      isOpen: notificationSectionPage?.length,
      section: MODAL_SECTION.RightSection
    }))

    dispatch(setChatSectionPage('clear'))
    dispatch(setSharingToFriends(false))
    dispatch(clearConnectedProfileChat())
    sessionStorage.setItem('isChatPanelOpen', 'false')
    sessionStorage.setItem('isSharingBlog', 'false')
    sessionStorage.removeItem('chosenFriends')
    dispatch(setChosenFriends([]))
    setSendBtnClicked(false)

    if (options?.showParamIds) {
      if (selectedEventData?.id) {
        setTimeout(() => setSearchParams({ eventid: selectedEventData.id }), 800)
      } else if (selectedMarkerData?.id) {
        setTimeout(() => setSearchParams({ id: selectedMarkerData.id }), 800)
      }
    } else if (!options?.fromAnimatePressence) {
      setTimeout(() => showCoordParams(setSearchParams), 800)

      const ZoomCont = document.querySelector('.leaflet-control-zoom')
      const filterData = document.querySelector('.filter-data')
      const markerCountBox = document.querySelector('.marker-count')
      ZoomCont.style.opacity = 1
      ZoomCont.style.pointerEvents = 'auto'
      filterData.style.opacity = 1
      filterData.style.pointerEvents = 'auto'
      markerCountBox.style.opacity = 1
      markerCountBox.style.pointerEvents = 'auto'
    }
  }

  const closeChatPanel = () => {
    if (isMobileImagePickerState && !isMobileImageTransferInprogress) {
      dispatch(endMobileImagePicker())
      dispatch(hideModalSpinner())
    }

    const isChatShown = xmppChatPanelOpened
    if (isChatShown) {
      const event = new CustomEvent('custom-chat-close_chat_panel')
      window.dispatchEvent(event)

      setIsPinned(false)
      setShowDropdown(false)
      setAttachmentBtnDisplay('none')
    } else {
      closeMessenger({ showParamIds: true })
    }
  }

  const headerTitle = () => {
    if (sharingToFriends) {
      return 'Share'
    }

    return attachmentBtnDisplay === 'none'
      ? 'Contacts'
      : 'Messages'
  }

  const whatToShow = () => {
    if (!user) {
      return (
        <Stack
          margin="16px 0"
          gap="16px 0"
        >
          <Text
            textAlign="center"
            backgroundColor="rgb(229, 229, 229)"
            borderRadius="3px"
            border="solid 1px black"
            padding="10px"
            margin="0 2% !important"
            fontSize="13px"
          >
            Create an account to chat with other users
          </Text>
        </Stack>
      )
    }

    if (
      userProfile
      && !userProfile.find((profile) => profile.is_active)
    ) {
      return (
        <Stack
          margin="16px 0"
          gap="16px 0"
        >
          <Text
            textAlign="center"
            backgroundColor="rgb(229, 229, 229)"
            borderRadius="3px"
            border="solid 1px black"
            padding="10px"
            margin="0 2% !important"
            fontSize="13px"
          >
            Create a profile to chat with other users
          </Text>
        </Stack>
      )
    }

    return converseRoot
  }

  const updateShareCount = () => {
    dispatch(sharePost(blogLinkToBeCopied.split('/?post-id=')[1]))
  }

  const animateVariants = {
    initial: { x: 500 },
    animate: {
      x: runHidePanel || runClosingAnimation ? 500 : 0,
      transition: {
        type: hidePanelAnimation || runClosingAnimation ? 'tween' : 'spring',
        duration: 0.8
      }
    },
    exit: {
      x: 500,
      transition: {
        type: 'tween',
        duration: 0.8
      }
    },
    exit0: {
      x: 500,
      transition: {
        type: 'tween',
        duration: 0
      }
    }
  }

  const handleContent = (pageName) => (
    <MotionBox
      id={`${pageName}-panel`}
      key={`${pageName}-panel`}
      variants={animateVariants}
      initial="initial"
      animate="animate"
      exit={chatSectionPage?.at(-1) === pageName ? 'exit' : 'exit0'}
      position="fixed"
      top="env(safe-area-inset-top)"
      right={0}
      height="calc(100dvh - 120px)"
      maxHeight="calc(100dvh - 120px - env(safe-area-inset-top))"
      display="flex"
      flexDirection="column"
      zIndex={1410}
      borderRadius="10px"
      overflow="hidden"
      marginBlock="60px"
      marginInline="10px"
      background="#c4c3c7"
      width="95% !important"
      maxWidth="450px"
      boxShadow="0 4px 10px rgba(0, 0, 0, 0.2) !important"
      sx={{
        '::-webkit-scrollbar': {
          display: 'none'
        },
        '-ms-overflow-style': 'none',
        'scrollbar-width': 'none'
      }}
    >
      <Box
        bg={COLORS.goldGradientRightToLeft}
        px="unset"
        py="5px"
        padding="0"
        height="48px"
        position="relative"
        flex="0 0 48px"
        onTouchStart={(e) => {
          touchStart = e?.targetTouches[0].clientX
        }}
        onTouchMove={(e) => {
          touchEnd = e?.targetTouches[0].clientX
        }}
        onTouchEnd={() => {
          if (touchStart - touchEnd < 45) {
            closeMessenger({ showParamIds: true })
          }
        }}
      >
        <Stack
          alignItems="center"
          justifyContent="space-between"
          direction="row"
          height="48px"
        >
          <Box>
            <IconButton
              _hover={{ background: COLORS.gold_hover }}
              background="unset"
              outline="none"
              boxShadow="none"
              height="40px"
              width="40px"
              marginLeft="5px"
              icon={<SettingsIcon />}
              onClick={() => {
                if (showDropdown) {
                  setHideDropdownAnimate(true)
                  setTimeout(() => {
                    setShowDropdown(!showDropdown)
                    setHideDropdownAnimate(false)
                  }, 300)
                } else {
                  setHideDropdownAnimate(false)
                  setShowDropdown(!showDropdown)
                }
              }}
              display={attachmentBtnDisplay}
            />
          </Box>

          {
            showDropdown
              ? (
                <DropdownStackParent>
                  <DropdownStack
                    initial={{ y: hideDropdownAnimate ? 0 : -100 }}
                    animate={{ y: hideDropdownAnimate ? -100 : 0 }}
                    transition={{
                      type: 'spring',
                      stiffness: 200,
                      damping: 22
                    }}
                  >
                    <DropdownCheckBox
                      ref={pinBtnRef}
                      onChange={() => {
                        setIsPinned(!isPinned)
                        dispatch(pinFriend(friendId))
                      }}
                      value="pinToTop"
                      isChecked={isPinned}
                    >
                      <Text fontSize="13px" fontWeight="400">Pin to top of contact list</Text>
                    </DropdownCheckBox>
                    <DropdownCheckBox value="shareLoc">
                      <Text fontSize="13px" fontWeight="400">Share my location</Text>
                    </DropdownCheckBox>
                  </DropdownStack>
                </DropdownStackParent>
              ) : ''
          }

          <Text
            whiteSpace="nowrap"
            fontSize="24px"
            fontWeight={600}
            paddingLeft="50px"
          >
            { headerTitle() }
          </Text>

          <Box>
            <IconButton
              _hover={{ background: COLORS.gold_hover }}
              background="unset"
              transform="rotate(180deg) scaleX(-1)"
              outline="none"
              boxShadow="none"
              height="40px"
              width="40px"
              icon={<PaperClipIcon />}
              onClick={() => {
                const sendAttachmentBtn = document.querySelector('#send-attachment-btn')

                if (sendAttachmentBtn) {
                  sendAttachmentBtn.click()
                }
              }}
              display={attachmentBtnDisplay}
            />

            <IconButton
              id="chat-back-btn"
              _hover={{ background: COLORS.gold_hover }}
              background="unset"
              transform="rotate(180deg)"
              outline="none"
              boxShadow="none"
              height="40px"
              borderRadius="5px"
              marginRight="5px"
              icon={<ArrowIcon />}
              onClick={() => closeChatPanel()}
              css={{
                ':focus': {
                  outline: 'none',
                  boxShadow: 'none'
                }
              }}
            />
          </Box>
        </Stack>
      </Box>

      <Box height="100%" width="100%">
        { whatToShow() }
      </Box>

      {
        sharingToFriends
          ? (
            <Box
              zIndex="1000"
              flexDirection="column"
              padding="0"
              margin="0"
            >
              {
                copyBtnClicked
                  ? (
                    <Text
                      bg={COLORS.gold}
                      width="100%"
                      height="80px"
                      display="flex"
                      flexDir="column"
                      alignItems="center"
                      justifyContent="center"
                      borderRadius="0 0 10px 10px"
                    >
                      <span>Thanks for sharing Connector!</span>
                      <span>Let's grow this community!</span>
                    </Text>
                  ) : (
                    <>
                      <Stack
                        width="100%"
                        display="flex"
                        flexDirection="row"
                        gap="0"
                        position="relative"
                      >
                        {
                          chosenFriends.length && !sendBtnClicked
                            ? (
                              <>
                                <Input
                                  bg={COLORS.gold}
                                  width="100%"
                                  placeholder="Add Message"
                                  border="solid 1px black"
                                  borderRight="none"
                                  borderRadius="0px"
                                  _focusVisible={{ borderColor: '' }}
                                  _hover={{ borderColor: '' }}
                                  value={msgInput}
                                  onChange={(e) => {
                                    setMsgInput(e.target.value)
                                    e.target.style.paddingRight = e.target.value ? '13%' : ''
                                  }}
                                  sx={{
                                    '::placeholder': {
                                      textAlign: 'center',
                                      color: 'black'
                                    }
                                  }}
                                />

                                <IconButton
                                  bg={COLORS.gold}
                                  outline="none"
                                  boxShadow="none"
                                  height="100%"
                                  width="10%"
                                  position="absolute"
                                  right="0"
                                  border="solid 1px black"
                                  borderRadius="0px"
                                  icon={<SendIcon />}
                                  _hover={{ background: COLORS.gold_hover }}
                                  onClick={() => {
                                    updateShareCount()

                                    dispatch(setMsgInputForBlogSharing(msgInput))

                                    const event = new CustomEvent('share-blog-to-friends')
                                    window.dispatchEvent(event)

                                    setSendBtnClicked(true)
                                    setTimeout(() => {
                                      setSendBtnClicked(false)
                                      setMsgInput('')
                                    }, 3000)
                                  }}
                                />
                              </>
                            ) : (
                              <Text
                                bg={COLORS.gray}
                                width="100%"
                                height="40px"
                                display="flex"
                                padding="0 5px"
                                alignItems="center"
                                justifyContent="center"
                                border="solid 1px black"
                                sx={{
                                  fontSize: sendBtnClicked ? 'clamp(10.5px, 1.5vw, 13px)' : ''
                                }}
                              >
                                {
                                  sendBtnClicked
                                    ? shareText
                                    : 'Choose contacts above'
                                }
                              </Text>
                            )
                        }
                      </Stack>

                      <Button
                        bg={chosenFriends.length ? COLORS.gray : COLORS.gold}
                        width="100%"
                        placeholder="Add Message"
                        borderRadius="0px"
                        fontWeight="400"
                        pointerEvents={chosenFriends.length ? 'none' : 'auto'}
                        onClick={() => {
                          updateShareCount()
                          navigator.clipboard.writeText(blogLinkToBeCopied)
                          setCopyBtnClicked(true)
                          setTimeout(() => setCopyBtnClicked(false), 3000)
                        }}
                        _hover={{ background: '' }}
                        _active={{ background: COLORS.gold }}
                      >
                        Copy link

                        <IconButton
                          bg="transparent"
                          outline="none"
                          boxShadow="none"
                          height="100%"
                          width="10%"
                          borderRadius="0px"
                          position="absolute"
                          right="0"
                          icon={<CopyIcon />}
                          _hover={{ background: '' }}
                        />
                      </Button>
                    </>
                  )
              }
            </Box>
          ) : ''
      }
    </MotionBox>
  )

  useEffect(() => {
    if (
      isXmppModalSpinnerHidden
      && meXmppIsOnline
      && getProfileItemStatus !== PENDING
    ) {
      setConverseRoot(<converse-root />)
    }
  }, [isXmppModalSpinnerHidden])

  useEffect(() => setConverseRoot(<LoadingSpinier />), [])

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const existing = document.querySelector('#send-attachment-btn')
      setAttachmentBtnDisplay(existing ? 'inline-flex' : 'none')
    })

    observer.observe(document.body, { childList: true, subtree: true })

    return () => observer.disconnect()
  }, [])

  useEffect(() => {
    if (attachmentBtnDisplay === 'none') {
      setShowDropdown(false)
    }
  }, [attachmentBtnDisplay])

  useEffect(() => {
    if (showDropdown) {
      const pinnedFriends = JSON.parse(localStorage.getItem('pinnedFriends'))

      if (
        pinnedFriends.length
        && pinnedFriends.find((friend) => friend.friendId === parseInt(friendId, 10))
        && pinBtnRef.current
        && !isPinned
      ) {
        setIsPinned(true)
      }
    }
  }, [showDropdown])

  useEffect(() => {
    if (openChatModal && !selectedMarkerData) {
      handleOpen()
    }
  }, [openChatModal])

  useEffect(() => {
    if (closeChatModal) {
      dispatch(setCloseChatModal(false))
      closeMessenger()
    }
  }, [closeChatModal])

  useEffect(() => {
    setHidePanelAnimation(true)
    setRunHidePanel(hideChat)
    setTimeout(() => setHidePanelAnimation(false), 800)
  }, [hideChat])

  useEffect(() => {
    if (closeAllDrawers) {
      closeMessenger()
    }
  }, [closeAllDrawers])

  useEffect(() => {
    if (blogLinkToBeCopied.includes('/?eventid=')) {
      setShareText('Event sent! Share with some friends who are not on Connector yet?')
    } else {
      setShareText('Article sent! Share with some friends who are not on Connector yet?')
    }
  }, [blogLinkToBeCopied])

  useEffect(() => {
    // This is to ensure that chat panel display chat list when sharing blog
    if (sharingToFriends && document.querySelector('#send-attachment-btn')) {
      const bckBtn = document.querySelector('#chat-back-btn')

      if (bckBtn) {
        bckBtn.click()
      }
    }
  }, [sharingToFriends])

  useEffect(() => {
    if (chatSectionPage.length === 1) {
      handleOpen()
    }
  }, [chatSectionPage])

  return (
    <>
      <StyleMessengerBlock
        zIndex={isAuth() ? 1401 : 1392}
        onClick={() => {
          if (isMobileImagePickerState && !isMobileImageTransferInprogress) {
            dispatch(endMobileImagePicker())
            dispatch(hideModalSpinner())
          }

          dispatch(handleOpenModal({
            isOpen: notificationSectionPage?.length,
            section: MODAL_SECTION.RightSection
          }))

          dispatch(setChatSectionPage('clear'))
          dispatch(setSharingToFriends(false))
          dispatch(clearConnectedProfileChat())
          sessionStorage.setItem('isChatPanelOpen', 'false')
          sessionStorage.setItem('isSharingBlog', 'false')
          sessionStorage.removeItem('chosenFriends')
          dispatch(setChosenFriends([]))
          setSendBtnClicked(false)

          document.querySelector('#custom-popup-overlay')?.click()
          document.querySelector('#custom-popup-overlay-event')?.click()

          dispatch(setUserSectionPage('clear'))
          dispatch(setOpenPopupBlogs(false))
          dispatch(setOpenPopupEvents(false))
          dispatch(setNotificationSectionPage('clear'))
          dispatch(setBlogRepostData([]))
          dispatch(setChatSectionPage('chat-main'))
        }}
      >
        <StyleNumUnread numUnread={numUnread}>
          { chatCounter(numUnread) }
        </StyleNumUnread>

        <Skeleton
          isLoaded={isLoaded}
          fadeDuration={1}
          borderRadius="full"
          boxSize="32px"
        >
          <Image
            boxSize="32px"
            cursor="pointer"
            objectFit="cover"
            src={ImagesPng.LogoHeader}
            alt="Logo"
            borderRadius="full"
            ref={btnRef}
            onLoad={() => setTimeout(() => setIsLoaded(true), 1000)}
          />
        </Skeleton>
      </StyleMessengerBlock>

      <AnimatePresence
        onExitComplete={() => {
          if (!chatSectionPage?.length) {
            closeMessenger({ fromAnimatePressence: true })
          }
        }}
      >
        {
          chatSectionPage?.length
          && (
            <>
              <Box
                zIndex={isAuth() ? 1399 : 1390}
                background="transparent"
                position="fixed"
                width="100%"
                height="50px"
                top={0}
                onClick={() => {
                  if (!closeAllDrawers) {
                    dispatch(setCloseAllDrawers(true))
                    setTimeout(() => dispatch(setCloseAllDrawers(false)), 850)
                  }
                }}
              />

              <Box
                zIndex={isAuth() ? 1399 : 1390}
                background="transparent"
                position="fixed"
                width="100%"
                height="50px"
                bottom={0}
                onClick={() => {
                  if (!closeAllDrawers) {
                    dispatch(setCloseAllDrawers(true))
                    setTimeout(() => dispatch(setCloseAllDrawers(false)), 850)
                  }
                }}
              />
            </>
          )
        }

        { chatSectionPage.map((pageName) => handleContent(pageName)) }
      </AnimatePresence>
    </>
  )
}
